import React, { useEffect, useState } from 'react';
import { MessageSquare, X, Sparkles } from 'lucide-react';
import AskNewAiPanel from './AskNewAiPanel';

interface AskNewAiWidgetProps {
  defaultOpen?: boolean;
}

const AskNewAiWidget: React.FC<AskNewAiWidgetProps> = ({ defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsOpen(false);
    };
    if (isOpen) {
      window.addEventListener('keydown', onKey);
    }
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen]);

  return (
    <>
      {!isOpen && (
        <button
          type="button"
          onClick={() => setIsOpen((prev) => !prev)}
          className="fixed bottom-4 right-4 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full shadow-lg px-4 py-3 flex items-center gap-2 z-40"
          title="Ask AI"
        >
          <MessageSquare className="w-5 h-5" />
          <span className="text-sm font-medium hidden sm:inline">Ask AI</span>
        </button>
      )}

      {isOpen && (
        <>
          {/* Backdrop overlay */}
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-20 transition-opacity"
            onClick={() => setIsOpen(false)}
          />
          {/* Chat panel */}
          <div className="fixed top-0 right-0 w-[630px] h-screen bg-white border-l border-gray-200 shadow-2xl z-30 flex flex-col">
            <div className="flex items-center justify-between px-4 py-2.5 border-b bg-gradient-to-r from-indigo-600 to-indigo-500 text-white flex-shrink-0">
              <div className="flex items-center gap-2">
                <Sparkles className="w-4 h-4 drop-shadow" />
                <div>
                  <div className="text-sm font-semibold">Complin AI Assistant</div>
                  <div className="text-[10px] opacity-90">Answers & guidance</div>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                className="p-1.5 hover:bg-white/15 rounded transition-colors"
                title="Close"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            <div className="flex-1 min-h-0 overflow-hidden">
              <AskNewAiPanel />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AskNewAiWidget;


